module.exports = __webpack_public_path__ + "static/media/PA zones.1ea86073.png";